import { render, staticRenderFns } from "./UploadSelectExtension.vue?vue&type=template&id=7aa3fa0a&scoped=true"
import script from "./UploadSelectExtension.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSelectExtension.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadSelectExtension.vue?vue&type=style&index=0&id=7aa3fa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa3fa0a",
  null
  
)

export default component.exports